export default __webpack_public_path__ + "static/media/Bandhavgarh-National-Park-and-Tiger-Reserve.4b535aa0.jpg";